import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NgOtpInputComponent } from 'ng-otp-input';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';

interface EventObject {
  [event: string]: any;
}

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss'],
})
export class OtpVerifyComponent implements OnInit {
  baseUrl: string = environment.BASE_URL;
  otp!: number;
  otpLength!: number;
  otpValidation!: boolean;
  companyEmail!: any;
  userDetails = {};
  userLead = {};
  customerCompanyProfile: EventObject = {};
  urlParams: any;
  @ViewChild('otpInput')
  otpInput!: NgOtpInputComponent;
  constructor(
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    private gtmService: GoogleTagManagerService,
  ) {}

  ngOnInit(): void {
    this.getEventData();
    this.companyEmail = sessionStorage.getItem('customeremail');
    this.userDetails = JSON.parse(sessionStorage.getItem('customeruser-details') || '{}');
    this.userLead = JSON.parse(sessionStorage.getItem('customeruser-lead') || '{}');
    this.customerCompanyProfile = JSON.parse(
      sessionStorage.getItem('customer-company-profile') || '{}',
    );
  }

  getEventData() {
    // event tracking for supplier registration
    this.urlParams = sessionStorage.getItem('event');
  }

  onOtpChange(event: any) {
    this.otp = event;
    this.otpLength = this.otp.toString().length;
    if (this.otpLength == 6) {
      this.otpValidation = false;
    }
  }

  verifyOtp() {
    const payload = {
      email: this.companyEmail.toLowerCase(),
      otp: Number(this.otp), // Convert OTP to number before sending
    };
    const apiUrl = `${this.baseUrl}auth-service/verifyOtp`;
    if (this.otpLength == 6 && !isNaN(payload.otp)) {
      this.otpValidation = false;
      this.commonService.postDatawithoutHeaders(apiUrl, payload).subscribe({
        next: (res: any) => {
          this.pushEvents();
          this.signUp();
        },
        error: (e) => {
          this.toastr.error(e.error.status.error.message);
        },
      });
    } else {
      this.otpValidation = true;
      this.toastr.error('OTP must be a 6-digit number');
    }
  }
  register() {
    this.otpInput.setValue('');
    this.commonService
      .postDatawithoutHeaders(`${this.baseUrl}auth-service/sendOtp`, {
        email: this.companyEmail,
        userName: JSON.parse(JSON.stringify(this.userDetails)).userName,
      })
      .subscribe((res) => {
        this.router.navigateByUrl('/registration/otp-verify');
        this.toastr.success('new OTP sent successfully');
      });
  }
  signUp() {
    if (this.urlParams) {
      this.customerCompanyProfile['event'] = this.urlParams;
    }
    const payload = {
      userDetail: JSON.parse(JSON.stringify(this.userDetails)),
      lead: JSON.parse(JSON.stringify(this.userLead)),
      customerCompanyProfile: JSON.parse(JSON.stringify(this.customerCompanyProfile)),
    };
    this.commonService
      .postDatawithoutHeaders(`${this.baseUrl}auth-service/signUp`, payload)
      .subscribe(
        (res) => {
          this.router.navigateByUrl('/registration/welcome');
          if (sessionStorage.getItem('event')) {
            sessionStorage.removeItem('event');
          }
        },
        (e) => {
          this.toastr.error(e.error.status.error.message);
        },
      );
  }
  getEmail(email: string): string {
    let encryptedEmail = '';
    let splitEmail1 = email?.split('@')[0]?.substring(1, email.split('@')[0]?.length);
    let splitEmail2 = email?.split('@')[1];
    for (let i = 0; i < splitEmail1?.length; i++) {
      encryptedEmail = encryptedEmail.concat('*');
    }
    if (email) {
      return `${email[0]}${encryptedEmail}@${splitEmail2}`;
    } else {
      return '';
    }
  }
  getLength(otp: number): boolean {
    return otp?.toString().length == 6 ? false : true;
  }

  pushEvents() {
    const gtmTag = {
      event: 'otp-verification',
      event_category: 'User Input',
      otp_verification: 'completed',
    };
    this.gtmService.pushTag(gtmTag);
  }
}
